<template>
  <div>
    <div v-if="!companyInfo && showLoading===false">
      <div class="wrapper flex">
        <p class="center mb-3">您无公司信息</p>
        <button block class="danger" @click="logout">退出登录</button>
      </div>
    </div>
    <div v-if="companyInfo">
      <div class="title">基本信息</div>
      <div class="wrapper flex">
        <p class="label required">公司名称:</p>
        <input v-model="companyInfo.name" type="text">
        <p class="label">行业类型:</p>
        <select v-model="companyInfo.industry" class="select mb-3">
          <option v-for="(comp,i) in industries" :key="i" :value="comp">{{ comp }}</option>
        </select>
        <p class="label">所在区域:</p>
        <div class="area">
          <span>(省)</span>
          <select v-model="companyInfo.province" @change="onProvinceChange">
            <option v-for="(comp,i) in provinces" :key="i" :value="comp">{{ comp }}</option>
          </select>
        </div>
        <div class="area">
          <span>(区)</span>
          <select v-model="companyInfo.city" @change="onCityChange">
            <option v-for="(comp,i) in cities" :key="i" :value="comp">{{ comp }}</option>
          </select>
        </div>
        <div class="area">
          <span>(市)</span>
          <select v-model="companyInfo.area">
            <option v-for="(comp,i) in areas" :key="i" :value="comp">{{ comp }}</option>
          </select>
        </div>
        <p class="label">邮编:</p>
        <input v-model="companyInfo.postalCode" type="text">
        <p class="label required">联系人:</p>
        <input v-model="companyInfo.contactName" type="text">
        <p class="label">职位:</p>
        <input v-model="companyInfo.contactTitle" type="text">
        <p class="label required">手机号码:</p>
        <input v-model="companyInfo.contactPhoneNumber" type="text">
        <p class="label">QQ:</p>
        <input v-model="companyInfo.contactQQ" type="text">
        <p class="label">邮箱:</p>
        <input v-model="companyInfo.contactEmail" type="text">
        <p class="label required">法人:</p>
        <input v-model="companyInfo.legalRepresentative" type="text">
        <p class="label required">电话:</p>
        <input v-model="companyInfo.phoneNumber" type="text">
        <p class="label required">注册地址:</p>
        <input v-model="companyInfo.registeredAddress" type="text">
        <p class="label">网址:</p>
        <input v-model="companyInfo.website" type="text">
        <p class="label">注册资本(万元):</p>
        <input v-model="companyInfo.registeredCapitalTenK" type="text">
        <p class="label">公司介绍:</p>
        <textarea v-model="companyInfo.description" rows="4"></textarea>
      </div>
      <div class="title">财务信息</div>
      <div class="wrapper flex">
        <p class="label required">税务性质:</p>
        <select v-model="companyInfo.taxType">
          <option v-for="(comp,i) in taxTypes" :key="i" :value="comp">{{ comp }}</option>
        </select>
        <p class="label required">税号:</p>
        <input v-model="companyInfo.taxId" type="text">
        <p class="label required">发票抬头:</p>
        <input v-model="companyInfo.receiptTitle" type="text">
        <p class="label">开户行:</p>
        <input v-model="companyInfo.bankBranch" type="text">
        <p class="label">开票地址:</p>
        <input v-model="companyInfo.receiptAddress" type="text">
        <p class="label">开票电话:</p>
        <input v-model="companyInfo.receiptPhoneNumber" type="text">
        <p class="label">银行账号:</p>
        <input v-model="companyInfo.bankAccountNumber" type="text">
        <button block class="info mb-3" @click="submit">提交</button>
        <button block class="danger" @click="logout">退出登录</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: "CompanyInfoForm",
    computed: {
      ...mapGetters(['companyInfo', 'industries', 'provinces', 'taxTypes', 'showLoading'])
    },
    data() {
      return {
        cities: [],
        areas: [],
      }
    },
    methods: {
      ...mapActions(['fetchIndustries', 'fetchProvinces', 'getCompanyInfo', 'fetchCities', 'fetchAreas', 'fetchTaxTypes', 'submitCompanyInfo']),
      submit() {
        console.log(this.companyInfo);
        this.submitCompanyInfo({companyId: this.companyInfo.companyId, item:this.companyInfo});
      },
      logout() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        location.href = '/login';
      },
      updateCities() {
        if (this.companyInfo.province) {
          this.fetchCities({
            province: this.companyInfo.province,
            callback: results => {
              this.cities = results;
            }
          });
        }
      },
      updateAreas() {
        if (this.companyInfo.province && this.companyInfo.city) {
          this.fetchAreas({
            province: this.companyInfo.province,
            city: this.companyInfo.city,
            callback: results => {
              this.areas = results;
            }
          });
        }
      },
      onProvinceChange() {
        this.companyInfo.city = null;
        this.companyInfo.area = null;
        this.cities = [];
        this.areas = [];
        this.updateCities();
      },
      onCityChange() {
        this.companyInfo.area = null;
        this.areas = [];
        this.updateAreas();
      },
    },
    created() {
      console.log(this.currentUser);

      if (this.currentUser.companyId) {
        this.fetchProvinces();
        this.fetchIndustries();
        this.fetchTaxTypes();
        this.getCompanyInfo(() => {
          this.updateCities();
          this.updateAreas();
        });
      }
    }
  }
</script>

<style scoped>
  .label {
    font-size: 14px;
    font-weight: bold;
    color: #999;
    margin-bottom: 0px;
    position: relative;
  }

  .label.required::before {
    content: '*';
    color: red;
    position: absolute;
    top: 1px;
    left: -10px;
  }

  input, select {
    width: 100%;
    height: 30px;
    border: none;
    border-bottom: 1px solid #000;
    outline: none;
    margin-bottom: 22px;
  }

  textarea {
    width: 100%;
    border: none;
    border-bottom: 1px solid #000;
    outline: none;
    margin-bottom: 22px;
  }

  .area {
    display: flex;
    align-items: center;
  }

  .area span {
    width: 50px;
    height: 40px;
    flex: 0 0 auto;
  }

  .title {
    background: #ddd;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
  }
</style>